import React from 'react'
import DateFormat from '../../shared/helpers/date-format'
import { getNonResidentText } from '../helpers/logic'

const { time } = DateFormat

const soldOut = availableSpots => {
  return availableSpots === 0
}

const pluralize = (word, number) => {
  return `${word}${number !== 1 ? 's' : ''}`
}

const availabilityLabel = (availableSpots, hideProductInventory) => {
  if (hideProductInventory) return ''
  let label = `(${availableSpots} ${pluralize(
    'space',
    availableSpots
  )} available)`
  if (soldOut(availableSpots)) {
    label = 'SOLD OUT'
  }
  return label
}

const formatTime = timeToFormat => time(timeToFormat, true).toLowerCase()

function EventTime({
  productId,
  timeInstance,
  availableSpots,
  selected,
  onSelectTime,
  hideProductInventory,
  isDynamicPricing
}) {
  const formattedTime = formatTime(timeInstance.occursAt)
  const timeId = `time-${timeInstance.id}`
  return (
    <li className="radio">
      <label
        className='cursor-pointer'
        htmlFor={timeId}
      >
        <input
          type="radio"
          onChange={onSelectTime}
          id={timeId}
          name={`event-${productId}`}
          checked={selected}
          disabled={availableSpots === 0}
          className='cursor-pointer'
        />
        <span>
          {formattedTime}{' '}
          <span
            className='xs-paragraph'
          >
            {availabilityLabel(availableSpots, hideProductInventory)}
          </span>
          {isDynamicPricing && (
            <span className="font-light">
              <br />
              {getNonResidentText(timeInstance)}
            </span>
          )}
        </span>
      </label>
    </li>
  )
}

export default EventTime
